export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s ei valittu';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s ei voi olla tyhjä';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s on pakollinen kenttä';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s ei täytetty oikein';
                break;

            case 'opt-in':
                translation = 'Merkitse valintaruutu jatkaaksesi';
                break;

            default:
                translation = 'Tätä kenttää ei täytetty oikein';
                break;
        }

        return translation;
    }
}
